import type { StockMediaItem, StockMediaLayerKind } from './types';

export interface MyUserMediaRow {
  id: string;
  url: string;
  kind: string; // 'image' | 'video' | 'audio' from the API
  name?: string | null;
  width?: number | null;
  height?: number | null;
  duration?: number | null;
}

/**
 * Adapts a personal-library row to the stock dialog's card model. Library
 * items carry no attribution (author null) and provider 'library'; missing
 * dimensions produce width/height 0, which stockItemToLayerInput maps to a
 * null aspect — the editor then probes at insert time. Also carries
 * `display_name` from the row's own `name`, since library items have no
 * author/provider attribution line to show instead.
 */
export function userMediaToStockItem(row: MyUserMediaRow): StockMediaItem | null {
  if (row.kind !== 'image' && row.kind !== 'video') return null;
  return {
    id: `library-${row.id}`,
    provider: 'library',
    kind: row.kind as StockMediaLayerKind,
    thumbnail_url: row.kind === 'image' ? row.url : '',
    preview_url: row.kind === 'video' ? row.url : null,
    file_url: row.url,
    width: row.width ?? 0,
    height: row.height ?? 0,
    duration: row.duration ?? null,
    author: null,
    author_url: null,
    source_url: null,
    download_location: null,
    display_name: row.name ?? null,
  };
}
